import cx from 'classnames'
import { useMemo } from 'react'
import CustomPhotosHeaderSlidingContent, {
  PhotoWithOrientation,
} from './CustomPhotosHeaderSlidingContent'
import { CuratedPhotoForPhotoProducts, FrameConfiguration } from '../types'

export interface HeaderImages {
  cutout: string
  static: string
}

export default function CuratedPhotosHeader({
  curatedPhotos,
  frameConfiguration,
  headerImages,
  isUsingFallback,
  frameOffsets,
  cutoutImageClassName,
}: {
  curatedPhotos: CuratedPhotoForPhotoProducts[]
  frameConfiguration: FrameConfiguration
  headerImages: HeaderImages
  isUsingFallback: boolean
  frameOffsets?: Array<{
    left: number
    top: number
    scale?: number
    rotate?: number
    zIndex?: number
  }>
  cutoutImageClassName?: string
}) {
  const photos: PhotoWithOrientation[] = useMemo(
    () =>
      isUsingFallback
        ? []
        : curatedPhotos.map(photo => ({
            url: photo.croppedUrl,
            isLandscape:
              !!photo.imageWidth && !!photo.imageHeight && photo.imageWidth > photo.imageHeight,
          })),
    [isUsingFallback, curatedPhotos],
  )

  if (photos.length < frameConfiguration.requiredPhotos) {
    return (
      <img
        src={headerImages.static}
        className={cx('w-full h-full object-cover', cutoutImageClassName)}
        loading='eager'
        width={frameConfiguration.width}
        height={frameConfiguration.height}
        style={{ aspectRatio: `${frameConfiguration.width}/${frameConfiguration.height}` }}
        alt='Header image'
      />
    )
  }

  return (
    <CustomPhotosHeaderSlidingContent
      photos={photos}
      frameOffsets={frameOffsets}
      cutoutImageClassName={cutoutImageClassName}
      cutoutImage={headerImages.cutout}
      frameConfiguration={frameConfiguration}
    />
  )
}
